import React from "react"

export const CaseStudyHero = ({
  titleHtml,
  backgroundUrl,
  backgroundUrlMobile,
}) => {
  const desktopImage = backgroundUrl ? `url(${backgroundUrl})` : undefined
  const mobileImage = backgroundUrlMobile
    ? `url(${backgroundUrlMobile})`
    : desktopImage

  return (
    <section
      className="hero case-study-detail-hero"
      style={{
        backgroundImage: desktopImage,
        backgroundSize: "cover",
        backgroundPosition: "top center",
        backgroundRepeat: "no-repeat",
        "--mobile-bg-image": mobileImage,
      }}
    >
      <div className="case-study-detail-hero-content">
        <h1
          className="case-study-detail-hero-title has-text-white"
          dangerouslySetInnerHTML={{ __html: titleHtml }}
        />
      </div>
    </section>
  )
}
